import { AfterViewInit, Component, inject } from '@angular/core';
import {Dossier} from '../../../class/api/Dossier';
import {ToolsService} from '../../services/tools/tools.service';
import {HydraService} from '../../../core/services/hydra.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {api} from '../../../api/api-dictionnary';
import {DossierExpert} from '../../../class/api/DossierExpert';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ModalCharteDeontologiqueComponent} from '../modal-charte-deontologique/modal-charte-deontologique.component';
import {DossierExpertAcceptationRequest} from '../../../class/api/DossierExpertAcceptationRequest';
import {DossierExpertRefusRequest} from '../../../class/api/DossierExpertRefusRequest';
import {Utilisateur} from '../../../class/api/Utilisateur';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatStepper, MatStep, MatStepperNext } from '@angular/material/stepper';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-resume-valid-experetise',
    templateUrl: './modal-resume-valid-expertise.component.html',
    styleUrls: ['./modal-resume-valid-expertise.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatStepper, MatStep, FormsModule, ReactiveFormsModule, MatCheckbox, MatButton, MatStepperNext, MatRadioGroup, MatRadioButton, MatDialogActions, MatDialogClose, TranslateModule]
})
export class ModalResumeValidExpertiseComponent implements AfterViewInit {
    toolService = inject(ToolsService);
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalResumeValidExpertiseComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    private _formBuilder = inject(UntypedFormBuilder);
    private matDialog = inject(MatDialog);

    public dossier: Dossier = null;
    public texte: any = null;
    public sommaire = [];
    public etatOrigine: number;
    public dossierExpert: DossierExpert;
    public displayCommentaire = false;
    public commentaire: string;
    public choix: string;
    // Controls for Stepper
    public firstFormGroup: UntypedFormGroup; // Validation du résumé

    public etatAcceptation: boolean;
    public etatcommentaire = '';

    isBusy = false;

    constructor() {
        this.dossierExpert = {...this.data.dossierExpert} as DossierExpert;
        this.etatOrigine = this.dossierExpert.etat;

        if (this.dossierExpert.etat == 1 || this.dossierExpert.etat == 4 || this.dossierExpert.etat == 5) {
            this.etatAcceptation = true;
        }else if(this.dossierExpert.etat == 2){
            this.etatAcceptation = false;
        }

        this.dossier = this.dossierExpert.dossier as Dossier;

        const commentaire: string | null = this.dossierExpert.commentaire;
        if (commentaire) {
            this.etatcommentaire = commentaire;
        }


        // Si l'etat est égal à 0 c'est que l'expert n'a jamais répondu à sa demande d'expertise
        let readAndValidateSummaryValue: string | boolean = '';
        if (this.dossierExpert.etat != 0) {
            readAndValidateSummaryValue = true;
        }
        this.firstFormGroup = this._formBuilder.group({
            readAndValidateSummary: [readAndValidateSummaryValue, Validators.required]
        });


    }

    ngAfterViewInit(): void {
        this.loadHTML();
    }


    loadHTML() {
        const url =
            api.voirResumeDossier
                .replace('{langue}', this.data.language)
                .replace('{id}', '' + this.data.id) + '?fullHtml=true';

        this.hydraService.getHtml(url).subscribe(
            res => {
                res = res.replace(`<section class="etape break">`, `<section>`);
                res = res.replace(`<div class="container">`, `<div class="">`);
                this.texte = res;
                this.editHtml();
            },
            err => {
            }
        );
    }

    save() {
        if(this.isBusy){
            return;
        }
        this.isBusy = true;

        if (this.etatAcceptation) {
            this.accepterExpertise();
        } else {
            this.refuserExpertise();
        }
    }

    accepterExpertise() {
        const data = new DossierExpertAcceptationRequest();
        data.dossierExpert = this.dossierExpert['@id'];
        data.declarationLien = this.etatcommentaire;

        this.hydraService.save('/api/dossier_experts/acceptation', data)
            .subscribe(
                (expertise) => {
                    this.isBusy = false;
                    this.toolService.notificationSuccess('Expertise mise à jour', 5000);
                    this.dialogRef.close(expertise);
                },
                () => {
                    this.isBusy = false;
                    this.dialogRef.close(false);
                }
            );
    }

    refuserExpertise() {
        const data = new DossierExpertRefusRequest();
        data.dossierExpert = this.dossierExpert['@id'];
        data.justification = this.etatcommentaire;

        this.hydraService.save('/api/dossier_experts/refus', data)
            .subscribe(
                (expertise) => {
                    this.isBusy = false;
                    this.toolService.notificationSuccess('Expertise mise à jour', 5000);
                    this.dialogRef.close(expertise);
                },
                () => {
                    this.isBusy = false;
                    this.dialogRef.close(false);
                }
            );
    }

    editHtml() {
        if (document.getElementById('iframeViwewer')) {
            document.getElementById('iframeViwewer').remove();
        }

        this.sommaire = [];
        const iframe = document.createElement('iframe');
        const html = this.texte;
        document.getElementById('content').appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);
        iframe.contentWindow.document.close();
        iframe.setAttribute('id', 'iframeViwewer');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('style', 'border:none; display:block;');

        window.setTimeout(() => {
            iframe.setAttribute(
                'min-height',
                iframe.contentWindow.document.body.scrollHeight + 'px'
            );
            iframe.setAttribute(
                'height',
                (iframe.contentWindow.document.body.scrollHeight + 50) + 'px'
            );
            const titres = iframe.contentWindow.document.getElementsByTagName(
                'h3'
            ) as any;
            for (let i = 0; i < titres.length; i++) {
                const item = titres[i] as HTMLElement;
                const id = this.toolService.getGUID();
                item.setAttribute('id', id);
                this.sommaire.push({
                    scrollTo: item.offsetTop,
                    label: item.innerText,
                });
            }
        }, 500);
    }


    public charteDeon() {
        const dialog = this.matDialog.open(ModalCharteDeontologiqueComponent, {
            data: false,
            panelClass: 'arc-dialog-panel', backdropClass: 'arc-dialog-backdrop'
        });
        const sub = dialog.afterClosed().subscribe(() => {
            sub.unsubscribe();
        });
    }

    public formatCandidatName() {
        const candidat: Utilisateur = this.dossier.candidat as Utilisateur;
        if(candidat.nom.length > 20) {
            return candidat.nom.substring(0,20) + '...'.toUpperCase();
        }
        return candidat.nom.toUpperCase();
    }

}
